module.exports = __webpack_public_path__ + "assets/retina_GivenAngleBisectorDetailed.ffea8cd095109035a7c9bb28013449be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_GivenAngleBisectorDetailed.png
// module id = 670
// module chunks = 0